import React from 'react'

export const Path: React.FC<{ path: string; }> = ({ path }: { path: string; }) => {
  return <path stroke="url(#grad)" strokeWidth={1} fill="none" d={path} />
}
